var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "deposit text-center" }, [
    _c("div", { staticClass: "f20 mar20-b text-left" }, [
      _vm._v(_vm._s(_vm.popupPrompt.desp))
    ]),
    _c(
      "div",
      [
        _vm.popupPrompt.isShow
          ? _c(
              "el-button",
              {
                staticClass: "mar60-l",
                attrs: { plain: "" },
                on: { click: _vm.setPopup }
              },
              [_vm._v("稍后缴费")]
            )
          : _vm._e(),
        _c(
          "el-button",
          {
            staticClass: "mar20-l f16",
            attrs: { type: "primary" },
            on: { click: _vm.toSetUp }
          },
          [_vm._v("去缴费")]
        )
      ],
      1
    ),
    _vm.popupPrompt.isShow
      ? _c("div", { staticClass: "red mar5-t" }, [
          _vm._v("点击稍后缴费后今日不再提示")
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }